import { ROUTE_NAME } from '@/lib/constant';

export default [
    {
        path: '/community',
        name: ROUTE_NAME.COMMUNITY,
        meta: {
            title: '社区',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
            popup: 'countdown',
        },
        component: () => import(/* webpackChunkName: "community" */ '@/pages/community/addIndex.vue'),
    },
    {
        path: '/community/publish/:signinId?',
        name: ROUTE_NAME.COMMUNITY_PUBLISH,
        meta: {
            title: '发表动态',
            scrollBehavior: 'top',
            scrollDefaultPosition: 0,
            needBinding: true,
            disableShare: true,
            needLoginNext: true,
        },
        component: () => import(/* webpackChunkName: "community" */ '@/pages/community/publish.vue'),
    },
    {
        path: '/community/:id',
        name: ROUTE_NAME.COMMUNITY_DETAIL,
        meta: {
            title: '发现',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
        },
        component: () => import(/* webpackChunkName: "community" */ '@/pages/community/detail.vue'),
    },
    {
        path: '/community/reply/:type/:id/:name?/:replyToId?/:replyId?', // 如果是回复的回复存在replyId
        name: ROUTE_NAME.COMMUNITY_REPLY,
        meta: {
            title: '发现',
            scrollBehavior: 'top',
            needBinding: true,
            disableShare: true,
            needLoginNext: true,
        },
        component: () => import(/* webpackChunkName: "community" */ '@/pages/community/reply.vue'),
    },
    {
        path: '/community/offline/activity',
        name: ROUTE_NAME.COMMUNITY_OFFLINE,
        meta: {
            title: '线下活动',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
        },
        component: () => import(/* webpackChunkName: "community" */ '@/pages/community/offline.vue'),
    },
];
